import {
  BooleanField,
  Datagrid,
  ReferenceField,
  TextInput,
  TextField,
  // SearchInput,
  SelectInput,
  NumberField,
  useTranslate,
  FunctionField,
} from 'react-admin'
import { ListBase } from '../../components/base'
// import { NameField, DateField } from '../../components/fields'
import {
  PRODUCTS_OTHER_FIELDS,
  PRODUCTS_COMMON_FIELDS,
  // COMMON_FIELDS,
} from '../../providers/localization/constant'
import { Product } from '../../types/product'
import { useProductExport } from '../../hooks/useProductExport'
import { ExportButton } from '../../components/buttons'
import DownloadIcon from '@mui/icons-material/GetApp'
import { ImportButton } from '../../components/buttons/ImportButton'

const OtherList = (): JSX.Element => {
  const translate = useTranslate()
  const otherListFilters = [
    // <TextInput
    //   key={0}
    //   source='prod_code'
    //   // InputLabelProps={{ shrink: true }}
    //   // InputProps={{ notched: false }}
    //   // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
    //   label={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
    // />,
    // <TextInput
    //   key={1}
    //   source='prod_brand_name'
    //   // InputLabelProps={{ shrink: true }}
    //   // InputProps={{ notched: false }}
    //   // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_brand_name.label`)}
    //   label={translate(`${PRODUCTS_COMMON_FIELDS}.prod_brand_name.label`)}
    // />,
    <TextInput
      key={0}
      source='prod_name'
      label={translate(`${PRODUCTS_COMMON_FIELDS}.prod_name.label`)}
    />,
    <TextInput
      key={1}
      source='prod_brand_code'
      label={translate(`${PRODUCTS_COMMON_FIELDS}.prod_brand_code.label`)}
    />,
    // <NumberInput
    //   key={2}
    //   source='sale_price'
    //   label={translate(`${PRODUCTS_COMMON_FIELDS}.sale_price.label`)}
    // />,
    // <TextInput
    //   key={3}
    //   source='price_remark'
    //   label={translate(`${PRODUCTS_COMMON_FIELDS}.price_remark.label`)}
    // />,
    <SelectInput
      key={4}
      label={`${PRODUCTS_COMMON_FIELDS}.special_flag.label`}
      source='special_flag'
      choices={[
        { id: 'B', name: `${PRODUCTS_COMMON_FIELDS}.special_flag.choices.B` },
        { id: 'H', name: `${PRODUCTS_COMMON_FIELDS}.special_flag.choices.H` },
        { id: 'P', name: `${PRODUCTS_COMMON_FIELDS}.special_flag.choices.P` },
      ]}
    />,
    <SelectInput
      key={5}
      label={`${PRODUCTS_COMMON_FIELDS}.prod_item_status.label`}
      source='prod_item_status'
      choices={[
        { id: 'N', name: `${PRODUCTS_COMMON_FIELDS}.prod_item_status.choices.N` },
        { id: 'D', name: `${PRODUCTS_COMMON_FIELDS}.prod_item_status.choices.D` },
      ]}
    />,
    <SelectInput
      key={6}
      label={`${PRODUCTS_COMMON_FIELDS}.has_slug.label`}
      source='has_slug'
      choices={[
        { id: true, name: `${PRODUCTS_COMMON_FIELDS}.has_slug.choices.true` },
        { id: false, name: `${PRODUCTS_COMMON_FIELDS}.has_slug.choices.false` },
      ]}
    />,
  ]

  const { exporter } = useProductExport(
    translate(`${PRODUCTS_OTHER_FIELDS}.filename`),
    (records: Partial<Product>[]): Partial<Product>[] => {
      const recordsForExport = records.map((record) => {
        return {
          id: record?.prod_code,
          prod_item_status: record?.prod_item_status,
          prod_brand_name: record?.prod_brand_name,
          prod_name_th: record?.prod_name_th,
          sale_price: record?.sale_price,
          price_remark: record?.price_remark, // ***
          promotion_sale_price: record?.promotion_sale_price,
          promotion_remark: record?.promotion_remark, // ***
          green_card_promotion_sale_price: record?.green_card_promotion_sale_price, // ***
          green_card_promotion_remark: record?.green_card_promotion_remark, // ***
          ev_card_promotion_sale_price: record?.ev_card_promotion_sale_price, // ***
          ev_card_promotion_remark: record?.ev_card_promotion_remark, // ***
          is_highlight: record?.is_highlight, // *** true  (check 'Y', 'y', 'N', 'n', 'true', 'false')
          special_flag: record?.special_flag, // *** ENUM 'B' | 'N' | 'P'
          prod_desc_en: record?.prod_desc_en, // ***
          prod_desc_th: record?.prod_desc_th, // ***
          image: record?.image?.name, // *** file รูป
          thumbnail: record?.thumbnail?.name, // *** file รูปthumbnail
          detail_image: record?.detail_image?.name, // *** file รูปรายโบรชัวร์
          video_url: record?.video_url, // ***
          warranty_image: record?.warranty_image?.name, // *** file รูปรายละเอียดประกัน
          slug_th: record?.slug_th, // ***
          slug_en: record?.slug_en, // ***
        } as unknown as Partial<Product>
      })

      return recordsForExport
    },
  )

  return (
    <ListBase
      exporter={exporter}
      listAction={{
        menuItems: [
          {
            label: `${PRODUCTS_COMMON_FIELDS}.import.title`,
            icon: <DownloadIcon />,
            button: (
              <ImportButton
                label={translate(`${PRODUCTS_COMMON_FIELDS}.import.title`)}
                variant='contained'
                to={'/import-product/products-other'}
              />
            ),
            visible: true,
          },
          {
            label: translate(`${PRODUCTS_COMMON_FIELDS}.export.title`),
            icon: <DownloadIcon />,
            button: (
              <ExportButton
                label={translate(`${PRODUCTS_COMMON_FIELDS}.export.title`)}
                variant='contained'
                key={10}
                maxResults={100000}
              />
            ),
            visible: true,
          },
        ],
      }}
      perPage={50}
      filters={otherListFilters}
      sort={{ field: 'prod_name_th', order: 'ASC' }}
    >
      <Datagrid rowClick='show' bulkActionButtons={null}>
        <BooleanField
          source='is_highlight'
          label={`${PRODUCTS_COMMON_FIELDS}.is_highlight.label`}
          textAlign='center'
        />
        <ReferenceField
          source='special_flag'
          reference='special-flags'
          label={`${PRODUCTS_COMMON_FIELDS}.special_flag.label`}
          sortBy='special_flag'
        >
          <TextField source='title_th'></TextField>
        </ReferenceField>
        <TextField
          source='prod_name_th'
          label={`${PRODUCTS_COMMON_FIELDS}.prod_name_th.label`}
        ></TextField>
        <TextField
          source='prod_name_en'
          label={`${PRODUCTS_COMMON_FIELDS}.prod_name_en.label`}
        ></TextField>
        <TextField
          source='prod_brand_code'
          label={`${PRODUCTS_COMMON_FIELDS}.prod_brand_code.label`}
        ></TextField>
        <NumberField
          source='sale_price'
          label={`${PRODUCTS_COMMON_FIELDS}.sale_price.label`}
        ></NumberField>
        <TextField
          source='price_remark'
          label={`${PRODUCTS_COMMON_FIELDS}.price_remark.label`}
        ></TextField>
        {/* <BooleanField
          source='is_active'
          label={`${COMMON_FIELDS}.status.label`}
          textAlign='center'
        /> */}
        <FunctionField
          textAlign='center'
          source='prod_item_status'
          label={`${PRODUCTS_COMMON_FIELDS}.prod_item_status.label`}
          render={({ prod_item_status: status }): string =>
            status === 'N'
              ? translate(`${PRODUCTS_COMMON_FIELDS}.prod_item_status.choices.N`)
              : translate(`${PRODUCTS_COMMON_FIELDS}.prod_item_status.choices.D`)
          }
          // sortable={false}
        />
      </Datagrid>
    </ListBase>
  )
}

export default OtherList
